
import {Component, Prop, Vue} from "vue-property-decorator";
import {formRules} from "@/utils/formRules";
import {TranslateResult} from "vue-i18n";
import {Getter} from "vuex-class";

@Component
export default class PinCode extends Vue {
  @Prop({default: null})
  public relayId: number;

  @Prop({default: null})
  public currentKey: any;

  @Prop({default: false})
  public displayPinPad: boolean;

  @Prop({default: null})
  public keyGuestId: number;

  @Prop({default: false})
  public loading: boolean;

  @Getter private currentUser: any;
  @Getter private isMobile: boolean;

  private pin: string = "";
  private loadingPinValidation: boolean = false;
  private valid: boolean = true;

  private error: TranslateResult = null;
  private rules: object = formRules;

  get anyLoadingState(): boolean {
    return this.loading || this.loadingPinValidation;
  }

  private keyDownEvent(e: KeyboardEvent) {
    if (e.key === "Enter") {
      this.validateKeyToGuest();
    }
  }

  private validateKeyToGuest(): void {
    this.error = null;
    this.loadingPinValidation = true;
    this.$store.dispatch("relays/pinVerificationToGuest", {
      relayId: this.relayId,
      pin: this.pin,
      guest: this.keyGuestId,
    }).then((res) => {
      this.$emit("valid-pin", this.currentUser);
    }).catch((err) => {
      this.error = this.$i18n.t("alerts.error.wrongPin");
    }).finally(() => {
      this.loadingPinValidation = false;
    });
  }
}
